"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const changes_subscribers_1 = require("./changes_subscribers");
/* IS STORE */
function isStore(value) {
    return !!changes_subscribers_1.default.get(value);
}
/* EXPORT */
exports.default = isStore;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXNfc3RvcmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaXNfc3RvcmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUNBLFlBQVk7O0FBRVosK0RBQXVEO0FBRXZELGNBQWM7QUFFZCxTQUFTLE9BQU8sQ0FBRyxLQUFVO0lBRTNCLE9BQU8sQ0FBQyxDQUFDLDZCQUFrQixDQUFDLEdBQUcsQ0FBRyxLQUFLLENBQUUsQ0FBQztBQUU1QyxDQUFDO0FBRUQsWUFBWTtBQUVaLGtCQUFlLE9BQU8sQ0FBQyJ9